import React from "react";

interface DetailItemProps {
    label: string;
    value: React.ReactNode; // Allow string, number, or JSX
    className?: string;      // Optional additional class names
}

const DetailItemRenderer: React.FC<DetailItemProps> = ({ label, value, className = '' }) => (
    <div className={`mb-3 ${className}`}>
        {/* Label Styling: Smaller, lighter, uppercase like table headers */}
        <div className="text-xs font-medium text-gray-500 uppercase tracking-wider mb-0.5">
            {label}
        </div>
        {/* Value Styling: Standard size, darker color */}
        <div className="text-sm text-gray-800 font-medium break-words">
            {value}
        </div>
    </div>
)

export const DetailItem = React.memo(DetailItemRenderer);